import { render, staticRenderFns } from "./agentReceipt.vue?vue&type=template&id=b70672a4&scoped=true"
import script from "./agentReceipt.vue?vue&type=script&lang=js"
export * from "./agentReceipt.vue?vue&type=script&lang=js"
import style0 from "./agentReceipt.vue?vue&type=style&index=0&id=b70672a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70672a4",
  null
  
)

export default component.exports